import { Grid, Typography } from '@mui/material'
import { FormType } from '../utils/sharedTypes'
import { resolveOpcoRemise } from '../utils/pricing'

type Props = {
  form: FormType
}

export default function FundingSummaryOPCO({ form }: Props) {
  const opcoRemise = resolveOpcoRemise(
    form.data.estimate?.amount || 0,
    form.data.opco_amount || 0,
    form.data.personal_funding || 0,
  )

  return (
    <Grid item>
      <Grid item container direction="row" justifyContent="space-between" wrap="nowrap">
        <Grid item>
          <Typography variant="body2">Prix du parcours de formation (TTC)</Typography>
        </Grid>
        <Typography variant="body1" sx={{ textAlign: 'right', fontWeight: 500 }}>
          {Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
          }).format(form.data.estimate?.amount || 0) || '-'}
        </Typography>
      </Grid>

      <Grid item container direction="row" justifyContent="space-between" wrap="nowrap">
        <Grid item>
          <Typography variant="body2">
            Montant pris en charge par votre OPCO (
            {form.data.funding_organism?.name || form.data.funding_organism?.code?.replace('_', ' ')})
          </Typography>
        </Grid>
        <Typography variant="body1" sx={{ textAlign: 'right', textDecorationLine: 'line-through', fontWeight: 500 }}>
          {Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
          }).format(form.data.opco_amount || 0) || '-'}
        </Typography>
      </Grid>

      {opcoRemise !== null && (
        <Grid item container direction="row" justifyContent="space-between" wrap="nowrap">
          <Grid item>
            <Typography variant="body2">Remise</Typography>
          </Grid>
          <Typography variant="body1" sx={{ textAlign: 'right', textDecorationLine: 'line-through', fontWeight: 500 }}>
            {Intl.NumberFormat('fr-FR', {
              style: 'currency',
              currency: 'EUR',
              maximumFractionDigits: 2,
            }).format(opcoRemise) || '-'}
          </Typography>
        </Grid>
      )}

      <Grid item container direction="row" justifyContent="space-between" wrap="nowrap">
        <Grid item>
          <Typography variant="body2">Reste à charge</Typography>
        </Grid>
        <Typography variant="body1" sx={{ textAlign: 'right', fontWeight: 500 }}>
          {Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 2,
          }).format(form.data.personal_funding || 0) || '-'}
        </Typography>
      </Grid>
    </Grid>
  )
}
